import { useCallback } from 'react';

import Dashboard from '../lib/api/Dashboard';

import useRequest from './useRequest';

const useUnplannedRoute = () => {

    const { data, error, loading, setRequest, setSuccess, setError } = useRequest();

    const fetchRoute = useCallback(async (id) => {
        try {

            setRequest();

            const { data = null } = await Dashboard.getUnplannedRoute(id);
            
            setSuccess(data);

            return data;

        } catch (error) {
            console.log('[useUnplannedRoute]', error);
            setError(error);
        }

    }, []);

    return {
        error,
        loading,
        route: data,
        fetchRoute
    };
}

export default useUnplannedRoute;
